export const zIndex = {
  layer: 1000,
  header: 9000,
  modal: 100000,
};
